import React, { useEffect, useState } from "react";
import {jwtDecode} from "jwt-decode";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useProfile } from "../context/ProfileContext";
import config from "../config";

import EditPet from "./EditPet";
const EditProfile = () => {
  const navigate = useNavigate();
  const { updateCustomer } = useProfile();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    contact: "",
    pincode: "",
    city: "",
    state: "",
  });
  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [cityError, setCityError] = useState("");
  const [pinError, setPinError] = useState("");
  const [stateError, setStateError] = useState("");

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const contact = decoded.data.customer_data.contact;

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "name" || name === "city" || name === "state") {
      // Allow only letters and spaces
      formattedValue = value.replace(/[^A-Za-z\s]/g, "");
      if (name === "name"){
        if (formattedValue!== value) {
          setNameError("Only letters, no numbers here!");
        } else {
          setNameError("");
        }
      }
      if (name === "city"){
        if (formattedValue!== value) {
          setCityError("Letters only for the city name.");
        } else {
          setCityError("");
        }
      }
      if (name === "state"){
        if (formattedValue!== value){
          setStateError("Only letters allowed for the state name.");
        } else {
          setStateError("");
        }
      }
      
    }
    if (name === "pincode") {
      // Allow only letters and spaces
      formattedValue = value.replace(/[^0-9\s]/g, "");
      if (formattedValue!== value){
        setPinError("Numbers only, please.");
      } else {
        setPinError("");
      }
    }
    if (name === "email") {
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setEmailError("Oops, that doesn’t look like a valid email.");
      } else {
        setEmailError("");
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue,
    }));
  };

  const getData = async () => {
    try {
      const token = localStorage.getItem("token");
  
      const response = await axios.post(
        `${config.API_BASE_URL}/customer/getcustomer`,
        { contact }, // body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFormData(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error.response?.data || error.message);
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    let hasError = false;
  
    // 🛡 Validation
    if (!formData?.name) {
      setNameError("Only letters, no numbers here!");
      hasError = true;
    } else setNameError("");
  
    if (!formData?.email) {
      setEmailError("Oops, that doesn't look like a valid email.");
      hasError = true;
    } else setEmailError("");
  
    if (!formData?.city) {
      setCityError("Letters only for the city name.");
      hasError = true;
    } else setCityError("");
  
    if (!formData?.pincode) {
      setPinError("Numbers only, please.");
      hasError = true;
    } else setPinError("");
  
    if (formData?.email && !validateEmail(formData?.email)) {
      setEmailError("Oops, that doesn't look like a valid email.");
      hasError = true;
    }
  
    if (!formData?.state) {
      setStateError("Only letters allowed for the state name.");
      hasError = true;
    } else setStateError("");
  
    if (hasError) return;
  
    try {
      // Use ProfileContext's updateCustomer function
      const result = await updateCustomer(formData);
      
      if (result) {
        toast.success("All set! Your profile has been updated.", { position: "top-center" });
        navigate("/");
      } else {
        toast.error("Failed to update profile. Please try again.", { position: "top-center" });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to update profile. Please try again.", { position: "top-center" });
    }
  };
  

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
    <div className="bg-[#FFFCF2] flex justify-center items-center py-8">
      <div className="w-full max-w-4xl bg-white shadow-md rounded-lg overflow-hidden m-5">
        <div className="ml-4">
          <h2 className="text-xl font-bold">My Info</h2>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData?.name}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              {nameError && <p className="text-red-500 text-sm mt-1">{nameError}</p>}
            </div>
            <div>
              <input
                type="text"
                name="email"
                value={formData?.email}
                placeholder="Email id"
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
            </div>
            <div>
              <input
                type="text"
                name="address"
                placeholder="Address"
                value={formData?.address}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              
            </div>
            <div>
              <input
                type="text"
                name="pincode"
                value={formData?.pincode}
                placeholder="Pincode"
                onChange={handleChange}
                minLength={6}
                maxLength={6}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              {pinError && <p className="text-red-500 text-sm mt-1">{pinError}</p>}
            </div>
            <div>
              <input
                type="text"
                name="city"
                value={formData?.city}
                placeholder="City"
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              {cityError && <p className="text-red-500 text-sm mt-1">{cityError}</p>}
            </div>
            <div>
              <input
                type="text"
                name="state"
                placeholder="State"
                value={formData?.state}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              {stateError && <p className="text-red-500 text-sm mt-1">{stateError}</p>}
            </div>
           
          </div>
          <div className="mt-6 flex justify-end">
            <button className="bg-[#FF6216] text-white px-4 py-2 rounded-md shadow-sm focus:outline-none" onClick={handleSubmit}>
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    <EditPet />
    </>
  );
};

export default EditProfile;
